import React, { FC } from 'react';
import styles from '../SiteReadyStep.scss';
import { Button } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import { useOrchestratorNavigation } from '@wix/gg-common-lib/orchestrator';
import { TextDivider } from 'components/TextDivider/TextDivider';
import { ActionId, StepId } from 'config/flow';
import { Player } from '@lottiefiles/react-lottie-player';
import animationData from 'assets/lotties/success-confetti.json';
import { StatusCompleteFilled, ArrowRight, AppMarket } from '@wix/wix-ui-icons-common';
import { biEvents } from 'api/bi-events';
import { BI_STEP_NAME } from 'config/bi-events';

export const SiteReadyStepContent: FC = () => {
  const { t } = useTranslation();
  const { navigate } = useOrchestratorNavigation();

  const handleUpgradeNow = () => {
    biEvents.actionClicked({
      screenName: BI_STEP_NAME[StepId.SiteReady],
      button_name: 'upgrade-now',
    });
    navigate(ActionId.RedirectToUpgradePlan);
  };

  const handleManageProducts = () => {
    biEvents.actionClicked({
      screenName: BI_STEP_NAME[StepId.SiteReady],
      button_name: 'manage-products',
    });
    navigate(ActionId.RedirectToDashboard);
  };

  return (
    <div className={styles.siteReadyStepContent}>
      <div className={styles.siteReadyStepContentAnimation}>
        <Player loop autoplay className={styles.siteReadyStepContentAnimationLottie} src={animationData} />
        <StatusCompleteFilled className={styles.siteReadyStepContentAnimationIcon} />
      </div>
      <div className={styles.siteReadyStepContentTypography}>
        <p className={styles.siteReadyStepContentTitle}>
          <Trans i18nKey="site-ready-step.content.title" components={{ br: <br /> }} />
        </p>
        <p className={styles.siteReadyStepContentDescription}>
          <Trans i18nKey="site-ready-step.content.description" components={{ br: <br /> }} />
        </p>
      </div>
      <Button size="large" skin="premium" onClick={handleUpgradeNow} suffixIcon={<ArrowRight />}>
        {t('site-ready-step.content.button.upgrade-now')}
      </Button>
      <TextDivider text={t('site-ready-step.content.buttons-divider')} />
      <Button skin="dark" priority="secondary" onClick={handleManageProducts} prefixIcon={<AppMarket />}>
        {t('site-ready-step.content.button.manage-products')}
      </Button>
    </div>
  );
};
